import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getDefaultFocusedViewFilterForSelectedFolder from '../getDefaultFocusedViewFilterForSelectedFolder';
import getDefaultSortBy from 'mini-mail-list-store/lib/utils/sort/mailSortHelper';
import MailFolderTableQuery from 'mini-mail-list-store/lib/store/schema/MailFolderTableQuery';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { default as mapFolderIdToBaseFolderId } from 'owa-service/lib/factory/folderId';
import { getFindConversationShape } from 'owa-mail-store/lib/services/utils/findConversationShapeUtil';
import { getListViewType } from 'owa-mail-store/lib/utils/getListViewType';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import {
    BINARY_SWITCH,
    FILTER,
    MailHeaderElementToFocus,
} from 'mini-mail-list-store/lib/store/schema/MailHeaderElementToFocus';

/**
 * Create the table query to load a mail folder
 * @param folderId the folderId
 * @param focusedViewfilter the focusedViewfilter
 * @param viewFilter the viewFilter
 * @return tableQuery the tableQuery that needed to load a mail folder
 */
export default function createMailFolderTableQuery(
    folderId: string,
    focusedViewFilter?: FocusedViewFilter,
    viewFilter?: ViewFilter,
    sourceElement?: MailHeaderElementToFocus
): MailFolderTableQuery {
    const viewFilterToSet = viewFilter ? viewFilter : 'All';
    const focusedViewFilterToSet =
        focusedViewFilter == null
            ? getDefaultFocusedViewFilterForSelectedFolder(folderId)
            : focusedViewFilter;

    const folderTableQuery: MailFolderTableQuery = {
        baseFolderId: mapFolderIdToBaseFolderId({ Id: folderId }),
        folderId: folderId,
        listViewType: getListViewType(),
        focusedViewFilter: focusedViewFilterToSet,
        viewFilter: viewFilterToSet,
        sortBy: getDefaultSortBy(),
        requestShapeName: getFindConversationShape(folderId),
        type: TableQueryType.Folder,
        shouldTryToUseSessionDataResponse: true,
        mailHeaderElementToFocus: null,
    };

    if (sourceElement) {
        folderTableQuery.mailHeaderElementToFocus =
            sourceElement === FILTER ? FILTER : BINARY_SWITCH;
    }

    return folderTableQuery;
}
